import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import './Breadcrumb.css'

function Breadcrumb() {

    const path = window.location.pathname.split('/').filter(Boolean);
    const displayPath = path.map((whichpath) =>
        whichpath === 'booking' ? 'Book Appoinment' : whichpath &&
            whichpath === 'profile-setting' ? 'Profile Settings' : whichpath &&
                whichpath === 'change-password' ? 'change password' : whichpath &&
                    whichpath === 'administration' ? 'Administration' : whichpath &&
                    whichpath === 'mitwankappointmentbydate' ? 'Appoinment by date' : whichpath &&
                        whichpath === 'my-clients' ? 'My Clients' : whichpath &&
                            whichpath === 'schedule-timing' ? 'schedule timings' : whichpath &&
                                whichpath === 'mitwankchangepassword' ? 'change password' : whichpath &&
                                    whichpath === 'clientmessages' ? 'Messages' : whichpath &&
                                        whichpath === 'newsletter' ? 'Newsletter' : whichpath &&
                                            whichpath === 'trash' ? 'Trash' : whichpath &&
                                                whichpath === 'delete-request' ? 'Delete Request' : whichpath &&
                                                    whichpath === 'booking' ? 'Book Appoinment' : whichpath &&
                                                        whichpath === 'profile-setting' ? 'Profile Settings' : whichpath &&
                                                            whichpath === 'change-password' ? 'Change Password' : whichpath

    );


    return (
        <nav className='admin_dashboard_breadcrumb_main_division' >
            <div className='d-flex justify-content-between'>
                <div>
                    <div className='admin_dashboard_breadcrumb_division'>
                        <p className='admin_dashboard_breadcrumb_title'>home</p>
                        <p className='admin_dashboard_breadcrumb_title1'>/</p>
                        <p className='admin_dashboard_breadcrumb_title2'>{displayPath[0]}</p>
                    </div>
                    <div>
                        <h1 className='admin_dashboard_breadcrumb_title_main'>{displayPath[1] ? displayPath[1] : displayPath[0]}</h1>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Breadcrumb